export default {
  default: {
    addComparable: 'Add Comparable',
    added: 'Added',
  },
}
